import { validateDeviceSelection } from 'src/utils/subscriptionStatus'
import { deviceSwitched, fetchResetTime, getConnectionStatus, setConnectionStatus } from 'src/store/apps/Common'
import { buildDeviceContext, createSwitchToken } from 'src/utils/deviceContext'

/** 切换设备时需清除的会话级 localStorage 缓存 */
const DEVICE_SCOPED_CACHE_KEYS = [
  'smsItem',
  'whatsappItem',
  'lineItem',
  'kikItem',
  'weChatItem',
  'MessengerItem',
  'messengerItem',
  'wechatItem',
  'waBusinessItem',
  'androidWhatsappItem'
]

/**
 * 从 DeviceUser 解析 Redux 选中键（优先 device_id，否则 username）。
 * @param {Object} [deviceUser]
 * @returns {string}
 */
export const resolveDeviceUserId = deviceUser => {
  if (!deviceUser) return ''

  return deviceUser.device_id != null && deviceUser.device_id !== ''
    ? String(deviceUser.device_id)
    : deviceUser.username || ''
}

/**
 * 统一设备切换入口：写 localStorage、清会话缓存、广播 deviceSwitched、刷新验证/连接状态。
 * 超 30 天失效设备禁止成为选中态。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.deviceUser] - 写入 DeviceUser；undefined 时不覆盖
 * @param {Object} [params.currentDevice] - 写入 currentDevice；undefined 时不覆盖
 * @param {string} [params.currentMode] - 平台模式；缺省读 localStorage
 * @param {boolean} [params.skipSelectionGuard] - 仅清空/非选中场景跳过校验
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */
export const switchDevice = ({
  dispatch,
  deviceUser,
  currentDevice,
  currentMode,
  skipSelectionGuard = false
}) => {
  const hasSelectionPayload =
    deviceUser !== undefined &&
    deviceUser != null &&
    typeof deviceUser === 'object' &&
    Object.keys(deviceUser).length > 0

  if (!skipSelectionGuard && hasSelectionPayload) {
    const check = validateDeviceSelection(deviceUser)
    if (!check.ok) {
      console.warn('[switchDevice] blocked lapsed device selection', check)

      return null
    }
  }

  const mode =
    currentMode !== undefined && currentMode !== null && currentMode !== ''
      ? currentMode
      : localStorage.getItem('currentMode') || ''

  // 先写 currentMode，再 dispatch，避免其它逻辑读到旧平台
  if (mode) {
    localStorage.setItem('currentMode', mode)
  }

  if (deviceUser !== undefined) {
    localStorage.setItem('DeviceUser', JSON.stringify(deviceUser))
  }

  if (currentDevice !== undefined) {
    localStorage.setItem('currentDevice', JSON.stringify(currentDevice))
  }

  DEVICE_SCOPED_CACHE_KEYS.forEach(key => localStorage.removeItem(key))

  const deviceId = resolveDeviceUserId(deviceUser)
  const storedDeviceUser =
    deviceUser !== undefined
      ? deviceUser
      : JSON.parse(localStorage.getItem('DeviceUser') || '{}')
  const storedCurrentDevice =
    currentDevice !== undefined
      ? currentDevice
      : JSON.parse(localStorage.getItem('currentDevice') || '{}')
  const deviceContext = buildDeviceContext({
    deviceUser: storedDeviceUser,
    currentDevice: storedCurrentDevice,
    currentMode: mode,
    switchToken: createSwitchToken()
  })
  localStorage.setItem('deviceContext', JSON.stringify(deviceContext))

  dispatch(deviceSwitched({ deviceUserId: deviceId, currentMode: mode, deviceContext }))
  dispatch(fetchResetTime())

  if (mode === 'Android-Local') {
    dispatch(getConnectionStatus())
  } else {
    dispatch(setConnectionStatus(false))
  }

  return deviceContext
}
